var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import React from 'react';
import styles from './AutosaveCheckbox.module.css';
export function BasicCheckbox(props) {
    var onChange = props.onChange, labelPlacement = props.labelPlacement, labelStyles = props.labelStyles, controlStyles = props.controlStyles, testId = props.testId, otherProps = __rest(props, ["onChange", "labelPlacement", "labelStyles", "controlStyles", "testId"]);
    var handleChange = function (event, checked) {
        if (props.readOnly)
            return;
        if (props.disabled)
            return;
        if (onChange)
            onChange(event, checked);
    };
    return (React.createElement(FormControlLabel, { labelPlacement: labelPlacement, control: React.createElement(Checkbox, __assign({}, otherProps, { checked: props.checked || false, disabled: props.disabled || props.readOnly, onChange: handleChange, "data-test-id": "checkbox_" + testId })), label: React.createElement("span", { className: styles.label, style: labelStyles }, props.label), style: controlStyles }));
}
